import classNames from "@/helpers/classNames";
import React from "react";

export const InputError = ({
  className,
  ...props
}: React.ComponentProps<"p">) => (
  <p className={classNames("text-sm text-red-600", className)} {...props} />
);
